import React, { Component } from 'react';
import './DrugTypeCard.css';
import Card from '../../components/card/Card';
import CheckBox from '../../inputs/checkBox/CheckBox';
import Label from '../../components/label/Label';
import mainAPI from '../../api/MainAPI';
import models from '../../model/models';
import toasts from '../../utils/toasts';
import { SettingRow } from '../../pages/settingsPage/SettingsPage';
import Input from '../../inputs/input/Input';
import debounce from 'lodash.debounce';
import UniversalDropDown from '../../components/universalDropDown/UniversalDropDown';

const categoryOptions = ['Veterinary', 'Law Enforcement', 'Controlled Substance', 'Non-Controlled Substance'];
export default class DrugTypeCard extends Component {
	constructor(props) {
		super(props);
		this.state = { search: '', category: '' };
	}

	_changeAllowedDrug = async (value, type) => {
		let res = null;
		if (!value) {
			res = await mainAPI.allowed_drug.delete({type})
		} else {
			res = await mainAPI.allowed_drug.create({type})
		}
		if (res) {
			models.drug_type.refreshData();
			toasts.show('Setting Updated');
		} else {
			toasts.show('Setting did not update');
		}
	};

	updateShortDate = async (value, type) => {
		await mainAPI.allowed_drug.delete({type}).catch(e=>console.log(e));
		let res = await mainAPI.allowed_drug.create({type, short_date_default_days:value})
		if (res) {
			await models.drug_type.refreshData();
			this.setState({lastUpdated:Date.now()})
			toasts.show('Setting Updated');
		} else {
			toasts.show('Setting did not update');
		}
	};

	categoryChange = (value) => {
		this.setState({ category: categoryOptions[value] || '' });
	};

	searchChange = (value) => {
		this.setState({ search: value.toLowerCase() });
	};

	render() {
		let drug_types = this.props.drugTypes || [];
		let allowedDrugs = Object.keys(models.drug_type.allowed());
		let displayTypes = [];
		for (let i in drug_types) {
			let drug_type = drug_types[i];
			if (
				// if the current drug does not include the string typed into the search bar
				!drug_type.name.toLowerCase().includes(this.state.search) ||
				// or if there is a selected category AND it is not equal to the current drug's category, continue
				(this.state.category && drug_type.categories.toLowerCase() !== this.state.category.toLowerCase())
			)
				continue;

			displayTypes.push(
				<SettingRow key={i}>
					<CheckBox
						tabIndex="0"
						value={isAllowed(drug_type.id, allowedDrugs)}
						onChange={(value) => {
							this._changeAllowedDrug(value, drug_type.id);
						}}
					/>
					<div className="list-labels">
						<Label className="drug-type col1" gray-dark>
							{drug_type.name}
							<Label small black>
								{' '}
								{' (' + (drug_type.display_unit_of_measurement || drug_type.unit_of_measurement) + ') '}
							</Label>
						</Label>
						<Label className="is-reusable col2" black>
							{drug_type.is_reusable === 1 ? 'Multi-Use' : 'Single-Use'}
						</Label>
						<Label className="col3" black>
							{drug_type.categories.replace(/,/g, ' ')}
						</Label>
						<Input value={drug_type.short_date_default_days} type={'number'} className={'short-date'} placeholder={'Short Date Days'} onChange={debounce((value) => {
							this.updateShortDate(value, drug_type.id);
						}, 1500)}/>
					</div>
				</SettingRow>
			);
		}
		return (
			<Card className={'g-drug-type-card ' + this.props.className}>
				<div className="list-labels fixed-to-top">
					<Label bold large black>
						Drugs
					</Label>
					<UniversalDropDown
						placeholder="Filter By Category"
						options={categoryOptions}
						onChange={this.categoryChange}
					/>
					<Input placeholder="Search By Name" onChange={this.searchChange} />
				</div>
				<div className="scroll-list">{displayTypes}</div>
			</Card>
		);
	}
}

let isAllowed = (drug_type, allowedDrugs) => {
	if (!allowedDrugs || !Array.isArray(allowedDrugs)) return false;
	if (allowedDrugs.includes(drug_type)) return true;
	return false;
};



// WEBPACK FOOTER //
// ./src/cards/drugTypeCard/DrugTypeCard.jsx